import { forwardRef, type SVGProps } from 'react';

export const ArticleExistsCheckSuccessIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ArticleExistsCheckSuccessIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_10918)">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
        <path
          clipRule="evenodd"
          d="M31.9049 29.1632C32.2036 29 32.3996 28.6832 32.3996 28.3184V19.6784C32.3996 19.3136 32.2036 18.9968 31.9049 18.8336L24.5316 14.5712C24.3823 14.456 24.1956 14.3984 23.9996 14.3984C23.8036 14.3984 23.6169 14.456 23.4676 14.5712L16.0943 18.8336C15.7956 18.9968 15.5996 19.3136 15.5996 19.6784V28.3184C15.5991 28.4923 15.645 28.663 15.7322 28.8119C15.8194 28.9609 15.9446 29.0824 16.0943 29.1632L23.4676 33.4256C23.6169 33.5408 23.8036 33.5984 23.9996 33.5984C24.1956 33.5984 24.3823 33.5408 24.5316 33.4256L31.9049 29.1632ZM18.4369 19.6784L23.9996 16.4624L29.5623 19.6784L23.9996 22.8944L18.4369 19.6784ZM26.8999 28.9718C26.9452 28.9906 26.9938 29 27.0456 29C27.0974 29 27.146 28.9906 27.1913 28.9718C27.2367 28.9533 27.2788 28.9217 27.3176 28.877L30.8931 24.7606C30.9644 24.6786 31 24.5723 31 24.4416C31 24.3113 30.9644 24.2051 30.8931 24.123C30.8219 24.041 30.7296 24 30.6164 24C30.5029 24 30.4106 24.041 30.3393 24.123L27.0456 27.915L25.6562 26.3154C25.585 26.2334 25.4943 26.1924 25.3842 26.1924C25.2741 26.1924 25.1834 26.2334 25.1121 26.3154C25.0409 26.3975 25.0036 26.5037 25.0002 26.634C24.9971 26.7647 25.0312 26.871 25.1024 26.953L26.7736 28.877C26.8124 28.9217 26.8545 28.9533 26.8999 28.9718Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_10918">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  );
});
